import styled from 'styled-components';

const Wrapper = styled.div`
  background: #2A2A2A;
  padding: 2rem 1rem;
  color: #fff;

  .footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .left-section,
  .right-section {
    flex: 1;
    min-width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer-logo {
    // height: 50px;
    object-fit: contain;
  }

  .nic-logo {
    // height: 40px;
    object-fit: contain;
  }

  .middle-section {
    flex: 3;
    text-align: center;
  }

  .white-a{
    color: white;
    text-decoration: none;
  }
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0 0 0.5rem 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 0.5rem;

    li {
      cursor: pointer;
      font-size: 0.9rem;
      &:hover {
        text-decoration: underline;
      }
    }

    .dot {
      font-size: 1rem;
      color: #aaa;
    }
  }

  .footer-copy {
    font-size: 0.85rem;
    color: #aaa;
  }

  @media (max-width: 768px) {
    .footer-container {
      flex-direction: column;
      text-align: center;
    }

    .left-section,
    .right-section {
      justify-content: center;
    }
  }

  .scroll-to-top-btn {
  position: fixed;
  bottom: 80px; // Adjust according to your layout
  right: 30px;
  z-index: 9999;
  background: none;
  border: none;
  cursor: pointer;
  color: #007bff; // or any color matching your theme
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.2);
    color: #0056b3;
  }
}

.modal-body{
  height : 28vh;
  overflow-y :scroll;
}
  .modal-header,{
        background: #051e2e;
    color: white;
        justify-content: space-between; 
  }

`;

export default Wrapper;
